import { render, staticRenderFns } from "./FormTemplateMultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=template&id=0be7fe37&scoped=true&"
import script from "./FormTemplateMultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateMultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateMultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=style&index=0&id=0be7fe37&prod&lang=scss&scoped=true&"
import style1 from "./FormTemplateMultipleChoiceSingleAnswerWithValueQuestion.vue?vue&type=style&index=1&id=0be7fe37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7fe37",
  null
  
)

export default component.exports